import { render, staticRenderFns } from "./userOrderInfo.vue?vue&type=template&id=175e48a4&scoped=true&"
import script from "./userOrderInfo.vue?vue&type=script&lang=js&"
export * from "./userOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./userOrderInfo.vue?vue&type=style&index=0&id=175e48a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e48a4",
  null
  
)

export default component.exports